import { render, staticRenderFns } from "./SelectAdminHubInstantClaim.vue?vue&type=template&id=80339d46&"
import script from "./SelectAdminHubInstantClaim.vue?vue&type=script&lang=js&"
export * from "./SelectAdminHubInstantClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports